/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'heroicons_outline:home',
        link: '/dashboard'
    },
    {
        id: 'property',
        title: 'Property',
        type: 'basic',
        icon: 'heroicons_outline:office-building',
        link: '/master/property'
    },
    {
        id: 'logs-api',
        title: 'Logs API',
        type: 'basic',
        icon: 'heroicons_outline:terminal',
        link: '/logs-api',
    },
    {
        id: 'visitor-analytics',
        title: 'Analytics',
        type: 'basic',
        icon: 'heroicons_outline:chart-bar',
        link: '/visitor',
    },
    {
        id: 'masters.master',
        title: 'Settings',
        type: 'collapsable',
        icon: 'heroicons_outline:cube',
        children: [
            {
                id: 'property-type',
                title: 'Property Type',
                type: 'basic',
                icon: 'heroicons_outline:cash',
                link: '/master/property-type'
            },
            {
                id: 'amenities',
                title: 'Amenities',
                type: 'basic',
                icon: 'heroicons_outline:server',
                link: '/master/amenities'
            },
            {
                id: 'email-template',
                title: 'Email Template',
                type: 'basic',
                icon: 'heroicons_outline:mail',
                link: '/master/email-template'
            },
            {
                id: 'cms-pages',
                title: 'Cms Pages',
                type: 'basic',
                icon: 'heroicons_outline:document',
                link: '/master/cms-pages'
            },
            {
                id: 'banner',
                title: 'Banners',
                type: 'basic',
                icon: 'heroicons_outline:film',
                link: '/master/banner'
            },
            {
                id: 'help-card',
                title: 'Help Card',
                type: 'basic',
                icon: 'heroicons_outline:bookmark',
                link: '/master/help-card'
            },
            {
                id: 'general-setting',
                title: 'General',
                type: 'basic',
                icon: 'heroicons_outline:cog',
                link: '/master/general-setting'
            },
            {
                id: 'title',
                title: 'Labeling',
                type: 'basic',
                icon: 'heroicons_outline:badge-check',
                link: '/master/title',
            },
            {
                id: 'country',
                title: 'Country',
                type: 'basic',
                icon: 'heroicons_outline:flag',
                link: '/master/country/list'
            },
            {
                id: 'state',
                title: 'State',
                type: 'basic',
                icon: 'heroicons_outline:globe',
                link: '/master/state/list'
            },
            {
                id: 'city',
                title: 'City',
                type: 'basic',
                icon: 'heroicons_outline:map',
                link: '/master/city/list'
            },
        ],
    },
    {
        id: 'blog',
        title: 'Blogs',
        type: 'basic',
        icon: 'heroicons_outline:template',
        link: '/blog/list',
    },
    {
        id: 'property-inquiry',
        title: 'Property Inquiry',
        type: 'basic',
        icon: 'heroicons_outline:information-circle',
        link: '/master/property-inquiry/list'
    },
    {
        id: 'customer',
        title: 'Customer',
        type: 'basic',
        icon: 'heroicons_outline:user-group',
        link: '/master/customer/list'
    },
    {
        id: 'contact',
        title: 'Contacts',
        type: 'basic',
        icon: 'heroicons_outline:user-circle',
        link: '/master/contact/list'
    },
    {
        id: 'manage-role',
        title: 'Access Role',
        type: 'basic',
        icon: 'heroicons_outline:lock-open',
        link: '/master/manage-role',
    },
    {
        id: 'manage-user',
        title: 'User',
        type: 'basic',
        icon: 'heroicons_outline:users',
        link: '/master/manage-user/',
    },
];